import { styled, Typography } from '@mui/material'

export const StyledMobLabel = styled(Typography)({
  fontSize: '12px',
  color: '#595959',
})

export const MailPhoneWrap = styled((props) => <Typography noWrap {...props} />)({
  '& a': {
    color: 'inherit',
  },
})
